const STATUS_LABELS = {
  pending: 'Queued',
  queued: 'Queued',
  generating: 'Generating',
  generated: 'Delivered',
  failed: 'Failed',
  expired: 'Expired',
  sent: 'Sent',
};

export const reportStatusLabel = (status) => STATUS_LABELS[status] || status;

export const reportStatusVariant = (status) => {
  if (['pending', 'queued', 'generating', 'sending'].includes(status)) return 'progress';
  if (['generated', 'sent'].includes(status)) return 'success';
  if (status === 'failed') return 'critical';
  return 'neutral';
};
